import React from 'react'
import { CContainer } from '@coreui/react-pro'
import { Link } from 'react-router-dom'
import { BRAND_COLOR } from '../../../config/site'
import { useSeo } from '../../../hooks/useSeo'

const Page404 = () => {
  useSeo({ title: 'Página no encontrada | DomicilApp', description: 'La página que buscas no existe.', index: false })

  return (
    <CContainer className="py-5 text-center" style={{ maxWidth: "560px" }}>
      <div className="display-1 fw-bold" style={{ color: BRAND_COLOR }}>404</div>
      <h1 className="h3 fw-bold text-dark">No encontramos esta página</h1>
      <p className="text-secondary mb-4">Puede que el enlace esté mal escrito o que la página ya no exista.</p>
      <div className="d-flex flex-wrap justify-content-center gap-3">
        <Link to="/" className="btn btn-dark fw-bold px-4">Ir al inicio</Link>
        <Link to="/contactus" className="btn btn-outline-dark fw-bold px-4">Pedir ayuda</Link>
      </div>
    </CContainer>
  )
}

export default Page404
